import { useCallback } from "react"
import moment from "moment"
import { usePreprocessedOffDays } from "../views/calendar/hooks/usePreprocessedOffDays"

export const useDateIncludeWorkingDays = (personnelId?: number) => {
    const { workingDays, offDays } = usePreprocessedOffDays(moment().year(), personnelId)

    return useCallback((dateMoment: moment.Moment) => {
        const isoDay = dateMoment.isoWeekday()
        const dayOfWeek = dateMoment.day()

        const isWorkingDay = workingDays.some((wd: any) => {
            if (!wd.startDate || !wd.endDate) return false

            if (wd.isWeeklyRepetitive) {
                const wdStart = moment(wd.startDate).local()
                const wdEnd = moment(wd.endDate).local()
                const startIso = wdStart.isoWeekday()
                const endIso = wdEnd.isoWeekday()

                const coveredWeekdays = new Set<number>()
                if (startIso <= endIso) {
                    for (let d = startIso; d <= endIso; d++) coveredWeekdays.add(d)
                } else {
                    for (let d = startIso; d <= 7; d++) coveredWeekdays.add(d)
                    for (let d = 1; d <= endIso; d++) coveredWeekdays.add(d)
                }

                return coveredWeekdays.has(isoDay)
            }

            const startStr = moment(wd.startDate).local().format('YYYY-MM-DD')
            const endStr = moment(wd.endDate).local().format('YYYY-MM-DD')
            return dateMoment.isBetween(startStr, endStr, 'day', '[]')
        })

        const isHoliday = offDays.some((od: any) => {
            if (!od.startDate || !od.endDate) return false
            const startStr = moment(od.startDate).local().format('YYYY-MM-DD')
            const endStr = moment(od.endDate).local().format('YYYY-MM-DD')
            const isDateInRange = dateMoment.isBetween(startStr, endStr, 'day', '[]')
            if(od.allowCriticalLeaveOnly && isDateInRange) return false

            return isDateInRange
        })

        const isCriticalDay = offDays.some((od: any) => {
            if (!od.startDate || !od.endDate) return false
            const startStr = moment(od.startDate).local().format('YYYY-MM-DD')
            const endStr = moment(od.endDate).local().format('YYYY-MM-DD')
            const isDateInRange = dateMoment.isBetween(startStr, endStr, 'day', '[]')
            return isDateInRange && od.allowCriticalLeaveOnly === true
        })

        return {
            isWorkingDay: isWorkingDay || (dayOfWeek !== 0 && dayOfWeek !== 6 && !isHoliday),
            isCriticalDay: isCriticalDay
        }
    }, [workingDays, offDays])
}